<!--其它出库  -->
<template>
	<div class="info-box">
		<el-dialog title="其它出库信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle"
			top="3vh">
						<div class="info-title">基本信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 单号: </span>
									<span class="ml15"> {{rowData.orderNo||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 计划日期: </span>
									<span class="ml15"> {{rowData.planDate||'无'}}</span>
								</div>
							</div>
							<!--  -->
								<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 客商名称: </span>
									<span class="ml15"> {{rowData.agentName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 客商SAP编号: </span>
									<span class="ml15"> {{rowData.sapAgentNo||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">路线: </span>
									<span class="ml15"> {{rowData.routeName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 巡回计划: </span>
									<span class="ml15"> {{rowData.planCode||'无'}}</span>
								</div>
							</div>
							<!--  -->
								<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 制单员: </span>
									<span class="ml15"> {{rowData.createdName||'无'}}</span>
								</div>
								
							</div>
							<!--  -->
							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 配送客商情况 -->
			
				<div class="info-title mt20">出库明细:</div>
				<el-table class="mt20" :data="tableData" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					 border style="width: 100%">
					 <el-table-column prop="outType" label="出库类型"></el-table-column>
					 <el-table-column prop="skuName" label="SKU"></el-table-column>
					 <el-table-column prop="productQuantity" label="数量"></el-table-column>
					 <el-table-column prop="storeName" label="出货仓"></el-table-column>
					 <el-table-column prop="productDate" label="生产日期"></el-table-column>
					 <el-table-column prop="ncSynbackinfo" label="SAP同步状态"></el-table-column>
				</el-table>
	
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
import {dateTimeFormat} from '@/utils/common'
	export default {
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				dateTimeFormat:null,
				ruleForm:{
					outStoreId: "",
				},
				rowData: {},
				tableData: [],
			}
		},
		created() {
			this.dateTimeFormat = dateTimeFormat
		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.rowData = {}
					this.pageNo = 1
					this.ruleForm = {
						outStoreId: "",
					}
					if (data) {
						this.ruleForm.outStoreId = data.dataKey
						this.getInfo()
					}
				})
			},
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"outStoreInfo",
						true, {
							outStoreId: that.ruleForm.outStoreId,
						}
					)
					.then((res) => {
						if (res) {
							that.tableData = res.data.agentOutStoreList
							that.rowData = res.data
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 330px;
			padding: 20px 20px 10px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}
	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}
</style>
